export const words = [
  '叮～解锁新一岁 ',
  '生日快乐 Sophia',
  '送上我祝福',
  '你的人生因你而精彩',
  '寿星今日营业中',
  '幸福绵长',
  '带着满满的祝福',
  '时光温柔以待',
  '又添一岁光彩',
  '生辰快乐',
  '心中有繁花似锦',
  '特别的日子有灿烂的笑容',
  // '趴在桌子上偷偷看你',
  // '你是我灰色人生中的一道彩虹',
  // '柳絮空缱绻',
  '每一天都精彩',
  // '我见青山多妩媚',
  // '料青山见我也应如是',
  // '取次花丛懒回顾',
  // '半缘修道半缘君',
  // '三笑徒然当一痴',
  '对所有的烦恼说bye bye',
  '对所有的快乐说hi hi',
  '愿好运连连',
  // '此恨不关风与月',
  // '因为你，我多少适应了这个世界',
  '愿你天天开心',
  '愿你幸福快乐',
  '今夜何夕',
  // '见此良人',
  '愿你如星君如月',
  '夜夜流光相皎洁',
  // '情不所起',
  // '一往而深',
  // '玲珑骰子安红豆',
  // '入骨相思知不知',
  // '多情只有春庭月',
  // '尤为离人照落花',
  // '若有知音见采',
  // '不辞唱遍阳春',
  // '休言半纸无多重',
  // '万斛离愁尽耐担',
  '好运常伴你身旁',
  '桂花浅深处',
  '愿你在新的一岁里找到更多的快乐和满足',
  '岁岁年年皆芳华',
  '生日快乐，青春永驻',
  '春水碧于天',
  '盈盈一水间',
  '夜月一帘幽梦',
  '愿你未来可期，生活幸福',
  '独倚望江楼',
  '愿你所愿皆所得，所行皆坦途',
  '平安喜乐',
  '和光同尘',
  '杳霭流玉',
  '月落星沉',
  '霞姿月韵',
  '诸事顺遂',
  '醉后不知天在水',
  '满船星梦压星河',
  '落花人独立',
  '每天都要甜甜的',
  '掬水月在手',
  '弄花香满衣',
  '愿你所念皆如愿',
  '生活明朗',
  '万物可爱',
  '皓腕凝霜雪',
  '众里嫣然通一顾',
  '人间颜色如尘土',
  '有趣有盼',
  '晚风尚好',
  '沉鱼落雁鸟惊喧',
  '羞花闭月花愁颤',
  '愿你快乐逍遥没烦恼',
  '沉香亭北倚阑干'
];

export const wordsToPhone = [
  '愿你似繁星璀璨',
  '岁岁年年皆安然',
  '曾照彩云归',
  '幸福满盈',
  '杯杯美酒杯杯福',
  '愿你在自己的花季',
  '表达我诚挚的祝愿',
  '点一支蜡烛闪闪幸福',
  '希望你放下思虑',
  '祝生日快乐！',
  '生活处处都有小幸运',
  '永远十八岁，生日快乐',
  '春水碧于天',
  '盈盈一水间',
  '祝Sophia生日快乐',
  '向雨儿借一阵凉意',
  '向云儿借一丝浪漫',
  '向风儿借一点自由',
  '向鸟儿借一份快乐',
  '花朝月夕',
  '如诗如画',
];